import type { RouteLane } from './types';

export type RouteMotion = 'flow' | 'none';
export type CardMotion = 'pulse' | 'none';

/**
 * Live routes may flow. Broken and quiet stay static.
 * prefers-reduced-motion / reduceMotion strips all motion marks.
 */
export function routeMotion(lane: RouteLane, reduceMotion = false): {
  className: string;
  motion: RouteMotion;
} {
  if (reduceMotion || lane !== 'live') {
    return { className: '', motion: 'none' };
  }
  return { className: 'df-route--flow', motion: 'flow' };
}

export function feedCardMotion(lane: RouteLane, reduceMotion = false): {
  className: string;
  motion: CardMotion;
} {
  if (reduceMotion || lane !== 'live') {
    return { className: '', motion: 'none' };
  }
  return { className: 'df-feed-card--pulse', motion: 'pulse' };
}

export function readPrefersReducedMotion(override?: boolean): boolean {
  if (override != null) return override;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
